import React from 'react';
import { TrendingUp } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { caseStudies } from '../data/mockData';

const CasosDeExito = () => {
    return (
        <div className="min-h-screen bg-[#1A1B1B] text-white selection:bg-[#D4AF37] selection:text-black">
            <Header />

            {/* Hero de la página */}
            <section className="pt-36 pb-10 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-b from-[#D4AF37]/5 to-transparent pointer-events-none" />
                <div className="container-custom relative z-10 text-center">
                    <span className="font-outfit text-sm uppercase tracking-widest text-[#D4AF37] font-semibold mb-4 block">
                        Casos de Éxito
                    </span>
                    <h1 className="heading-1 mb-4">
                        Empresas que ya{' '}
                        <span className="text-gradient">evolucionaron</span>
                    </h1>
                    <div className="gold-divider"></div>
                    <p className="body-large max-w-2xl mx-auto mt-6">
                        Resultados reales de clientes que confiaron en Evolvance para transformar su negocio.
                    </p>
                </div>
            </section>

            {/* Grid de casos */}
            <section className="section-padding bg-[#0F0F0F]">
                <div className="container-custom">
                    <div className="text-center mb-12">
                        <h2 className="heading-3 text-white">¿Quieres resultados como estos?</h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                        {caseStudies.map((study, index) => (
                            <div
                                key={study.id}
                                className="card-featured overflow-hidden hover-lift animate-fade-in-up flex flex-col h-full"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                {/* Image */}
                                <div className="relative h-48 overflow-hidden">
                                    <img
                                        src={study.image}
                                        alt={study.title}
                                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#252525] via-transparent to-transparent"></div>
                                </div>

                                {/* Content */}
                                <div className="p-6 flex flex-col flex-grow">
                                    <div className="inline-block bg-[#D4AF37]/10 border border-[#D4AF37]/30 px-3 py-1 rounded-full mb-4">
                                        <span className="font-outfit text-[10px] uppercase tracking-wider text-[#D4AF37] font-semibold">
                                            {study.client}
                                        </span>
                                    </div>

                                    <h3 className="text-xl font-outfit font-bold text-white mb-3 group-hover:text-[#D4AF37] transition-colors">{study.title}</h3>
                                    <p className="body-medium text-[#B1B1B1] text-sm mb-6 flex-grow">{study.description}</p>

                                    <div className="flex items-center gap-2 p-3 bg-[#D4AF37]/5 border border-[#D4AF37]/20 rounded-lg mt-auto">
                                        <TrendingUp className="w-5 h-5 text-[#D4AF37] flex-shrink-0" />
                                        <span className="font-outfit text-sm font-semibold text-[#D4AF37]">
                                            {study.results}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <p className="body-medium italic text-[#555]">...y muchos más que están por venir...</p>
                    </div>

                    {/* CTA */}
                    <div className="text-center mt-24">
                        <div className="inline-block glass-card p-10 max-w-2xl border border-[#D4AF37]/20 shadow-2xl">
                            <h3 className="text-2xl font-outfit font-bold mb-4 text-white uppercase tracking-wider">¿Tu empresa es la siguiente?</h3>
                            <p className="body-medium mb-8 text-[#B1B1B1]">
                                Cada proyecto es único. No vendemos software genérico, construimos motores de crecimiento personalizados para negocios reales.
                            </p>
                            <a
                                href="https://calendly.com/admin-evol-vance/evolweb"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-primary py-4 px-10 rounded-full shadow-gold"
                            >
                                Agendar Consultoría Gratuita
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default CasosDeExito;
